// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.gameConfig h2{\r\n    padding: 10px;\r\n    margin: 10px 0;\r\n    font-size: 16px;\r\n    -webkit-box-shadow: -4px 1px 3px 0px #e7e8e8;\r\n            box-shadow: -4px 1px 3px 0px #e7e8e8;\n}\r\n\r\n\r\n", ""]);
// Exports
module.exports = exports;
